import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import Sidebar from '../Layout/Sidebar';
import OverviewDashboard from '../Dashboard/OverviewDashboard';
import AddTransaction from '../Transactions/AddTransaction';
import StockAnalysis from '../Stocks/StockAnalysis';
import FuturesAnalysis from '../Futures/FuturesAnalysis';
import DataManager from '../DataManagement/DataManager';
import Settings from '../Settings/Settings';
import OptionChain from '../OptionChain';
import OptionStrategies from '../OptionStrategies/OptionStrategies';
import WheelStrategy from '../WheelStrategy/WheelStrategy';
import SubscriptionStatus from '../Subscription/SubscriptionStatus';
import UserProfile from '../Profile/UserProfile';
import MarketScanner from '../MarketScanner/MarketScanner';
import CommandCenter from '../CommandCenter/CommandCenter';
import api from '../../services/api';

function DashboardLayout() {
  const { user } = useAuth();
  const [currentMenu, setCurrentMenu] = useState('داشبورد کلان (پورتفوی کلی)');
  const [settings, setSettings] = useState([]);
  const [selectedSymbol, setSelectedSymbol] = useState(null);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const data = await api.get('/api/settings');
      setSettings(data);
    } catch (error) {
      console.error('خطا در دریافت تنظیمات:', error);
    }
  };

  const renderContent = () => {
    switch (currentMenu) {
      case 'داشبورد کلان (پورتفوی کلی)':
        return <OverviewDashboard settings={settings} />;
      case 'ثبت معامله':
        return <AddTransaction settings={settings} onTransactionAdded={fetchSettings} />;
      case 'پورتفوی':
        return <StockAnalysis
          settings={settings}
          preselectedSymbol={selectedSymbol}
          onPreselectedUsed={() => setSelectedSymbol(null)}
        />;
      case 'تحلیل بازار آتی (Futures)':
        return <FuturesAnalysis settings={settings} />;
      case 'مدیریت داده‌ها (ویرایش/حذف)':
        return <DataManager />;
      case 'زنجیره آپشن (تحلیل زنده)':
        return <OptionChain />;
      case 'استراتژی‌های آپشن':
        return <OptionStrategies />;
      case 'فرصت‌های بازار':
        return <MarketScanner />;
      case 'مرکز تصمیم‌گیری':
        return <CommandCenter />;
      case 'استراتژی چرخه (Wheel Strategy)':
        return <WheelStrategy />;
      case 'تنظیمات کمیسیون':
        return <Settings settings={settings} onSettingsUpdate={fetchSettings} />;
      case 'حساب کاربری':
        return <UserProfile />;
      default:
        return <OverviewDashboard settings={settings} />;
    }
  };

  return (
    <div className="app">
      <Sidebar
        onMenuSelect={setCurrentMenu}
        currentMenu={currentMenu}
        user={user}
      />
      <div className="main-content">
        <SubscriptionStatus />
        {renderContent()}
      </div>
    </div>
  );
}

export default DashboardLayout;
